import { render, staticRenderFns } from "./GroupbuyList.vue?vue&type=template&id=7bfa4efe&"
import script from "./GroupbuyList.vue?vue&type=script&lang=js&"
export * from "./GroupbuyList.vue?vue&type=script&lang=js&"
import style0 from "./GroupbuyList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports